export enum BannerSource {
    /** Яндекс */
    direct = 'direct',
    /** mail.ru */
    target = 'target',
}

export interface IRbJsonItem {
    count: number;
    format: string;
    is_expensive?: string;
    nodeId: string;
    source: BannerSource;
}

export interface IRbJsonItemWithFallback extends IRbJsonItem {
    fallback?: IRbJsonItem[];
}

export type IRbJson = IRbJsonItemWithFallback[];
